<ion-content>
  <div class="header"></div>
  <ion-grid class="constrained-content grid">
    <ion-row>
      <ion-col size="12">
        <div class="profile-photo">
          <app-avatar [name]="profile ? profile.name : ''" [image]="profile ? profile.photo : null" [size]="500">
          </app-avatar>
        </div>
        <div *ngIf="isInEditMode && canEditPhoto">
          <label for="profile-file-upload" class="custom-file-upload">
            <ion-icon name="cloud-upload" class="icon-padded"></ion-icon> Upload photo
          </label>
          <input
            id="profile-file-upload"
            accept="image/png, image/jpeg, image/jpg, image/gif"
            type="file"
            (change)="detectProfilePhotoUpload($event)"
          />
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-md="8" size="12">
        <ion-row>
          <ion-col size="12" class="name-section" [hidden]="isInEditMode">
            <div class="name-label flex-space-between">
              <h1>{{name}}</h1>
              <div>
                <ion-button
                  color="primary"
                  *ngIf="isSelf || isAdmin"
                  fill="clear"
                  class="btn-small hidden-sm"
                  (click)="isInEditMode = true"
                >
                  Edit profile
                </ion-button>
                <ion-button shape="round" class="btn-small round-button" (click)="showProfileOptions(profile)">
                  <ion-icon name="ellipsis-vertical"></ion-icon>
                </ion-button>
              </div>
            </div>
            <div>
              <a
                (click)="copyLink(profile.email)"
                *ngIf="profile?.email"
                ngxTippy
                data-tippy-content="Copy to clipboard"
              >
                <ion-icon name="mail-outline" class="padded-icon"></ion-icon>
                {{profile.email}}
              </a>
              <ion-badge color="success" *ngIf="profile?.isExternal" style="margin: -5px 5px"> Customer </ion-badge>
            </div>
            <div style="margin: 15px 0 0 0" *ngIf="profile && !isInEditMode && profile.status === 'inactive'">
              <ion-button color="danger" [disabled]="true">
                <ion-icon name="warning-outline" class="padded-icon"></ion-icon>
                Account deactivated
              </ion-button>
              <ion-button fill="clear" color="dark" *ngIf="isAdmin" class="btn-small" (click)="toggleIsActive()">
                <ion-icon name="arrow-up-outline" class="padded-icon"></ion-icon>
                Reactivate
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="!isInEditMode && allConversations?.length && !profile?.isExternal">
          <ion-col size="12" size-md="6">
            <ion-card class="outline-card report-card">
              <span class="report-stat">
                <span class="stat-large">{{ medianFirstResponse }}</span>
                <span class="stat-small">{{ medianFirstResponseLabel }}</span>
              </span>
              <div class="report-title">Median response time</div>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-card class="outline-card report-card">
              <span class="report-stat">
                <span class="stat-large">{{ medianResolution }}</span>
                <span class="stat-small">{{ medianResolutionLabel }}</span>
              </span>
              <div class="report-title">Median resolution time</div>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" *ngIf="!isInEditMode">
            <h3 style="margin-bottom: 15px">Recent conversations</h3>
            <ion-card class="outline-card">
              <div
                *ngIf="allConversations && !allConversations.length"
                class="empty-state-container"
                style="padding: 60px"
              >
                <span class="placeholder-emoji">
                  <ion-icon name="file-tray-outline"></ion-icon>
                </span>
                <h1 class="placeholder-title">No conversations yet</h1>
                <p class="placeholder-subtitle">This person hasn't tracked any conversations on Unthread.</p>
              </div>
              <ngx-datatable
                class="material"
                columnMode="force"
                [limit]="100"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="50"
                [scrollbarH]="true"
                [rows]="allConversations"
                [reorderable]="true"
                *ngIf="allConversations && allConversations.length"
              >
                <ngx-datatable-column name="ID" prop="friendlyId" [maxWidth]="64" [minWidth]="64" [sortable]="false">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <a
                      [routerLink]="['/dashboard/inbox/all/conversations', row.id]"
                      routerDirection="root"
                      title="{{ value }}"
                      ><strong>{{ value }}</strong>
                    </a>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Message" prop="initialMessage" [minWidth]="400" [sortable]="false">
                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <a
                      [routerLink]="['/dashboard/inbox/all/conversations', row.id]"
                      routerDirection="root"
                      title="{{ formatContent(row) }}"
                    >
                      <strong>{{ formatContent(row) }}</strong>
                    </a>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Status" [maxWidth]="170" [minWidth]="170">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div
                      class="status-label status-label-needs-response"
                      *ngIf="value === 'open'"
                      style="font-size: 0.8rem"
                    >
                      <ion-icon name="custom-open"></ion-icon>
                      Needs response
                    </div>
                    <div
                      class="status-label status-label-in-progress"
                      *ngIf="value === 'in_progress'"
                      style="font-size: 0.8rem"
                    >
                      <ion-icon name="custom-in-progress"></ion-icon>
                      In Progress
                    </div>
                    <div
                      class="status-label status-label-on-hold"
                      *ngIf="value === 'on_hold'"
                      style="font-size: 0.8rem"
                    >
                      <ion-icon name="custom-on-hold"></ion-icon>
                      On Hold
                    </div>
                    <div class="status-label status-label-closed" *ngIf="value === 'closed'" style="font-size: 0.8rem">
                      <ion-icon name="custom-closed"></ion-icon>
                      Closed
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Date" prop="createdAt" [minWidth]="100" [sortable]="false">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    {{ value | date: 'MMM d yyyy h:mm a' }}
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col size-md="4" size="12" class="about-section" [hidden]="isInEditMode">
        <div
          *ngIf="!profile?.isExternal && (isSelf || isAdmin)"
          style="margin-bottom: 15px; border-bottom: 1px solid var(--ion-color-step-100); padding-bottom: 15px"
        >
          <h3>
            <ion-icon name="lock-closed-outline" ngxTippy data-tippy-content="Only you can see this"></ion-icon>
            Settings
          </h3>

          <ion-card class="outline-card no-margin">
            <ion-radio-group [(ngModel)]="isAway">
              <ion-list>
                <ion-item>
                  <ion-radio slot="start" class="item-left-accessory" [value]="false"></ion-radio>
                  <ion-label text-wrap>Active</ion-label>
                </ion-item>
                <ion-item>
                  <ion-radio slot="start" class="item-left-accessory" [value]="true"></ion-radio>
                  <ion-label text-wrap>Away</ion-label>
                </ion-item>
              </ion-list>
            </ion-radio-group>
            <div *ngIf="isAway" style="margin: 0px 10px 10px 40px">
              Returning:
              <app-datetime-picker
                [initialDate]="getInitialDate()"
                [initialTime]="getInitialTime()"
                (datetimeChanged)="setAwayUntil($event)"
              >
              </app-datetime-picker>
            </div>
          </ion-card>

          <span class="input-label">Backup rep</span>
          <ion-chip
            style="margin: 0 0 15px 0; width: 100%; height: 39px; padding-right: 14px"
            mode="ios"
            class="select-outline"
            [outline]="true"
            (click)="selectBackupRep($event)"
          >
            <ion-label style="display: flex; width: 100%; justify-content: space-between">
              {{ backupRepName ?? 'Select backup user' }}
              <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
            </ion-label>
          </ion-chip>

          <div [hidden]="authService.tenant?.isInternalSupport">
            <span class="input-label">Can be assigned conversations automatically?</span>
            <ion-select
              interface="popover"
              class="select-outline"
              [(ngModel)]="isAutoAssignable"
              [compareWith]="isAutoAssignableCompareFn"
              style="width: 100%; padding: 10px; margin-bottom: 15px"
            >
              <ion-select-option [value]="null">Default ({{isAutoAssignableDefaultLabel()}})</ion-select-option>
              <ion-select-option [value]="true">Yes</ion-select-option>
              <ion-select-option [value]="false">No</ion-select-option>
            </ion-select>
          </div>

          <span class="input-label">Send new assignment notifications via Unthread</span>
          <ion-select
            interface="popover"
            class="select-outline"
            [(ngModel)]="isAssignmentNotificationEnabled"
            style="width: 100%; padding: 10px; margin-bottom: 15px"
          >
            <ion-select-option [value]="true">Yes</ion-select-option>
            <ion-select-option [value]="false">No</ion-select-option>
          </ion-select>

          <span class="input-label">Show in-channel ephemeral notifications</span>
          <ion-select
            interface="popover"
            class="select-outline"
            [(ngModel)]="isNewConversationNotificationEnabled"
            style="width: 100%; padding: 10px; margin-bottom: 15px"
          >
            <ion-select-option [value]="true">Yes</ion-select-option>
            <ion-select-option [value]="false">No</ion-select-option>
          </ion-select>

          <span class="input-label">Time format</span>
          <ion-select
            interface="popover"
            class="select-outline"
            [(ngModel)]="use24HourTime"
            style="width: 100%; padding: 10px; margin-bottom: 15px"
          >
            <ion-select-option [value]="true">24-hour (13:30)</ion-select-option>
            <ion-select-option [value]="false">12-hour (1:30 PM)</ion-select-option>
          </ion-select>

          <div *ngIf="isSelf">
            <span class="input-label">Slack permissions</span>
            <ion-card class="outline-card">
              <ion-list class="no-padding">
                <ion-item class="no-padding">
                  <ion-label> Connect private channels </ion-label>
                  <ion-label slot="end" *ngIf="!isConnectingSlack" [color]="hasUserChannelScope ? 'success' : 'danger'">
                    <ion-icon [name]="hasUserChannelScope ? 'checkmark-outline' : 'close-circle'"></ion-icon>
                  </ion-label>
                  <ion-spinner name="crescent" slot="end" *ngIf="isConnectingSlack"></ion-spinner>
                </ion-item>
                <ion-item class="no-padding">
                  <ion-label> Send messages as self </ion-label>
                  <ion-label
                    slot="end"
                    *ngIf="!isConnectingSlack"
                    [color]="hasUserChatWriteScope ? 'success' : 'danger'"
                  >
                    <ion-icon [name]="hasUserChatWriteScope ? 'checkmark-outline' : 'close-circle'"></ion-icon>
                  </ion-label>
                  <ion-spinner name="crescent" slot="end" *ngIf="isConnectingSlack"></ion-spinner>
                </ion-item>
                <ion-item class="no-padding">
                  <ion-label> Manage emoji reactions </ion-label>
                  <ion-label
                    slot="end"
                    *ngIf="!isConnectingSlack"
                    [color]="hasUserReactionScope ? 'success' : 'danger'"
                  >
                    <ion-icon [name]="hasUserReactionScope ? 'checkmark-outline' : 'close-circle'"></ion-icon>
                  </ion-label>
                  <ion-spinner name="crescent" slot="end" *ngIf="isConnectingSlack"></ion-spinner>
                </ion-item>
                <ion-button
                  fill="clear"
                  (click)="authorizeSlack()"
                  *ngIf="!isConnectingSlack && (!hasUserChatWriteScope || !hasUserChannelScope || !hasUserReactionScope)"
                  class="btn-small"
                >
                  <ion-icon name="logo-slack" class="padded-icon"></ion-icon>
                  Authorize Slack
                </ion-button>
              </ion-list>
            </ion-card>
          </div>

          <div *ngIf="isAdmin">
            <span class="input-label">Automatically connect new shared channels?</span>
            <ion-select
              interface="popover"
              class="select-outline"
              [(ngModel)]="autoAddBotCondition"
              placeholder="Connect Unthread to new shared channels?"
              style="width: 100%; padding: 10px; margin-bottom: 15px"
              [compareWith]="autoAddBotCompareFn"
            >
              <ion-select-option value="ask"> Ask before connecting new channels </ion-select-option>
              <ion-select-option value="always"> Always connect new channels </ion-select-option>
              <ion-select-option value="never"> Don't automatically connect </ion-select-option>
            </ion-select>
          </div>

          <div *ngIf="isAdmin">
            <span class="input-label">Which type of channels should auto-connect?</span>
            <ion-select
              interface="popover"
              class="select-outline"
              [(ngModel)]="autoAddBotChannelType"
              placeholder="Which channels should auto-connect?"
              style="width: 100%; padding: 10px; margin-bottom: 15px"
              [compareWith]="autoAddBotCompareFn"
            >
              <ion-select-option value="shared"> Shared channels (via Slack Connect) </ion-select-option>
              <ion-select-option value="all"> All channels </ion-select-option>
            </ion-select>
          </div>
          
          <div *ngIf="isAdmin && autoAddBotCondition === 'always'">
            <span class="input-label">(Advanced) Only connect channels with a prefix</span>
            <ion-input placeholder="Example: ext-shared" [(ngModel)]="autoAddBotRegex" class="input-field"></ion-input>
          </div>

          <div *ngIf="isAdmin && autoAddBotChannelType === 'all'">
            <span class="input-label">(Advanced) Override channel type?</span>
            <ion-select
              interface="popover"
              class="select-outline"
              [(ngModel)]="autoAddBotInternalOverride"
              style="width: 100%; padding: 10px; margin-bottom: 15px"
              [compareWith]="autoAddBotCompareFn"
            >
              <ion-select-option [value]="null"> None </ion-select-option>
              <ion-select-option [value]="false"> External customer channel </ion-select-option>
              <ion-select-option [value]="true"> Internal support channel </ion-select-option>
            </ion-select>
          </div>

          <div style="margin-bottom: 15px">
            <span style="display: block" class="input-label">Default inbox view</span>
            <ion-chip
              style="margin: 0px; width: 100%; height: 39px; padding-right: 14px"
              mode="ios"
              class="select-outline"
              [outline]="true"
              (click)="selectDefaultInboxView()"
            >
              <ion-label style="display: flex; width: 100%; justify-content: space-between">
                {{ defaultInboxView?.title ?? 'Select default inbox view' }}
                <ion-icon name="caret-down-outline" class="icon-padded-left"></ion-icon>
              </ion-label>
            </ion-chip>
          </div>

          <ion-button (click)="save(true)" [disabled]="isLoading">Save</ion-button>
        </div>

        <h3>About</h3>

        <div *ngIf="profile">
          <div class="sidebar-section-text" [innerHTML]="autolinker.link(description)"></div>
          <div class="sidebar-section-text" *ngIf="!profile.description">
            <i style="opacity: 0.7">No description</i>
          </div>
        </div>

        <div>
          <div *ngIf="profile?.status === 'inactive' || profile?.deleted">
            <div class="custom-field-title">Status</div>
            <div class="custom-field-value">Inactive</div>
          </div>
          <div *ngFor="let field of defaultFields">
            <div *ngIf="field.public && field.value">
              <div class="custom-field-title">{{field.title}}</div>
              <div class="custom-field-value">{{field.value}}</div>
            </div>
          </div>
          <div *ngFor="let field of customFields">
            <div *ngIf="field.public && field.value">
              <div class="custom-field-title">{{field.label ?? field.title}}</div>
              <div class="custom-field-value">{{field.value}}</div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="profile && !profile.isExternal">
          <h3>Email signature</h3>

          <div *ngIf="emailSignature">
            <div class="sidebar-section-text" [innerHTML]="autolinker.link(emailSignature)"></div>
          </div>
          <div class="sidebar-section-text" *ngIf="!emailSignature">
            <i style="opacity: 0.7">None</i>
          </div>
        </ng-container>

        <h3 style="margin-top: 30px">Channels</h3>

        <ion-card *ngIf="communities" class="outline-card no-margin">
          <div class="sidebar-section-text" *ngIf="!communities.length">
            <i style="opacity: 0.7">No customers</i>
          </div>
          <ion-list class="transparent-bg community-list">
            <ion-item
              *ngFor="let customer of communities"
              button="true"
              (click)="viewCustomer(customer)"
              class="ion-no-padding"
            >
              <ion-label style="margin-left: 10px; font-weight: 500; font-size: 0.9rem"> {{customer.name}} </ion-label>
            </ion-item>
          </ion-list>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isInEditMode">
      <ion-col size="12" size-sm="4" class="padded-column">
        <span class="input-label"> Name </span>
        <ion-input placeholder="Johnny Hammersticks" [(ngModel)]="name" class="input-field"> </ion-input>
        <span class="input-label"> Phone </span>
        <ion-input placeholder="+1 555 (555)-5555" [(ngModel)]="phone" class="input-field"> </ion-input>
        <span class="input-label"> Email </span>
        <ion-input placeholder="tree@meister.com" [(ngModel)]="email" class="input-field" [disabled]="!canEditEmail">
        </ion-input>
        <ng-container *ngFor="let field of defaultFields">
          <ng-container *ngIf="field.public">
            <span class="input-label"> {{field.title}} </span>
            <ion-input [(ngModel)]="this[field.id]" class="input-field"> </ion-input>
          </ng-container>
        </ng-container>

        <app-response-input [responseInputFields]="customFields" [showPublicOption]="true"></app-response-input>
      </ion-col>
      <ion-col size="12" size-sm="8" class="padded-column">
        <span class="input-label"> About </span>
        <div class="input-field" style="margin-left: 0; margin-right: 0">
          <ion-textarea
            autoGrow
            placeholder="Add a custom profile description that others can see"
            [(ngModel)]="description"
            style="--padding-top: 0"
          ></ion-textarea>
        </div>

        <span class="input-label"> Email signature </span>
        <div class="input-field" style="margin-left: 0; margin-right: 0">
          <ion-textarea
            autoGrow
            placeholder="Enter HTML here..."
            [(ngModel)]="emailSignature"
            style="--padding-top: 0"
          ></ion-textarea>
        </div>
        <div [innerHTML]="autolinker.link(emailSignature)"></div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="isInEditMode">
  <ion-toolbar class="constrained-content">
    <ion-button color="success" [disabled]="isLoading" (click)="save()">
      <ion-icon name="checkmark" class="icon-padded" *ngIf="!isLoading"></ion-icon>
      <ion-spinner name="crescent" style="margin-right: 10px" *ngIf="isLoading"></ion-spinner>
      <span *ngIf="isLoading">Saving...</span>
      <span *ngIf="!isLoading">Save</span>
    </ion-button>
    <ion-button fill="clear" color="primary" [disabled]="isLoading" (click)="isInEditMode = false"> Cancel </ion-button>
  </ion-toolbar>
</ion-footer>
